<template>
  <div v-if="card">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <router-link :to="{name: 'loyaltyCards'}">powrót</router-link>
              </div>
              <div class="col-sm-6 text-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-credit-card"></i>
            Karta lojalnościowa
            <div class="card-header-actions">
              <a class="card-header-action"
                 target="_blank"
                 v-if="card.clientId"
                 v-bind:href="'/api/loyalty-cards/print/' + card.loyaltyId">
                Wydrukuj kartę
              </a>
              <a href="#" @click.prevent="toggleIsActive()"
                 v-has-permissions="50"
                 class="card-header-action">
                <span v-if="card.isActive">Archiwizuj kartę</span>
                <span v-if="!card.isActive">Aktywuj kartę</span>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">{{ $t('loyaltyCards.cardNumber')}}</div>
              <div class="col-md-7">{{ card.cardNumber }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">{{ $t('loyaltyCards.cardType')}}</div>
              <div class="col-md-7">{{ $t('loyaltyCards.level.' + card.cardType)}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">{{ $t('clients.clientId')}}</div>
              <div class="col-md-7">
                {{ card.clientId }}
                <span class="badge badge-danger mr-2" v-if="!card.clientId">Błąd migracji</span>
                <a href @click.prevent="toggleAssignClientForm()"
                   v-has-permissions="50"
                   v-if="!card.clientId">Przypisz klienta</a>
                <a href @click.prevent="searchClient()"
                   class="ml-2"
                   v-if="!card.clientId"
                   v-has-permissions="50">(Znajdź)</a>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">Utworzony</div>
              <div class="col-md-7">{{ card.created | datetime }}</div>
            </div>
            <div class="row">
              <div class="col-md-5">Komentarz</div>
              <div class="col-md-7">{{ card.comment }}</div>
            </div>
          </div>
        </div>
        <div class="card" v-if="card.client">
          <div class="card-header">
            <i class="fa fa-credit-card"></i>
            Klient
            <div class="card-header-actions">
              <router-link class="card-header-action"
                           :to="{name: 'clientDetails', params: { clientId: card.clientId } }">
                Zobacz
              </router-link>
            </div>
          </div>
          <client-details-card v-bind:client="card.client"></client-details-card>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card" v-if="card.migration">
          <div class="card-header">
            <i class="fa fa-folder-open"></i>
            Dane zmigrowanej karty
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">name</div>
              <div class="col-md-7">{{ card.migration.name}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">adres</div>
              <div class="col-md-7">{{ card.migration.adres}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">postalCode</div>
              <div class="col-md-7">{{ card.migration.postalCode}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">city</div>
              <div class="col-md-7">{{ card.migration.city}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">province</div>
              <div class="col-md-7">{{ card.migration.province}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">country</div>
              <div class="col-md-7">{{ card.migration.country}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">pesel</div>
              <div class="col-md-7">{{ card.migration.pesel}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">nip</div>
              <div class="col-md-7">{{ card.migration.nip}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">contactName</div>
              <div class="col-md-7">{{ card.migration.contactName}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">county</div>
              <div class="col-md-7">{{ card.migration.county}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">leadId</div>
              <div class="col-md-7">{{ card.migration.leadId}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">leadType</div>
              <div class="col-md-7">{{ card.migration.leadType}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">loyalityCardNr</div>
              <div class="col-md-7">{{ card.migration.loyalityCardNr}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">status</div>
              <div class="col-md-7">{{ card.migration.status}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">phone</div>
              <div class="col-md-7">{{ card.migration.phone}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">mail</div>
              <div class="col-md-7">{{ card.migration.mail}}</div>
            </div>


            <div class="row">
              <div class="col-md-5">productId</div>
              <div class="col-md-7">{{ card.migration.productId}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">seller</div>
              <div class="col-md-7">{{ card.migration.seller}}</div>
            </div>
            <div class="row">
              <div class="col-md-5">source</div>
              <div class="col-md-7">{{ card.migration.source}}</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <loyalty-card-assign-client
        @assign-cancel="toggleAssignClientForm()"
        @assign-success="getCardData()"
        v-bind:loyalty-id="card.loyaltyId"
        v-if="assignClientFormVisible">
    </loyalty-card-assign-client>
  </div>
</template>

<script>
  import loyaltyCardsService from '@Service/loyaltyCards';
  import ClientDetailsCard from '@Component/client-details-card';
  import LoyaltyCardAssignClient from '@Component/loyalty-card-assign-client';
  import { router } from '@Router';
  import { toastSuccess, toastError } from '../helpers';

  export default {
    components: {
      LoyaltyCardAssignClient,
      ClientDetailsCard,
    },
    data() {
      return {
        card: null,
        assignClientFormVisible: false,
      };
    },
    methods: {
      getCardData: function () {
        loyaltyCardsService.getItem(this.$route.params.loyaltyId)
          .then(({ data }) => {
            this.card = data;
          });
      },
      toggleIsActive: function () {
        loyaltyCardsService.updateCardActiveStatus(this.card)
          .then(() => {
            this.card.isActive = !this.card.isActive;
            toastSuccess(this.$t(`messages.cards.${this.card.isActive ? 'activate' : 'deactivate'}.success`));
          })
          .catch(toastError);
      },
      toggleAssignClientForm: function () {
        this.assignClientFormVisible = !this.assignClientFormVisible;
      },
      searchClient: function () {
        let splitted;
        try {
          splitted = this.card.migration.name.split(' ');
        } catch (e) {
          splitted = [this.card.migration.name, ''];
        }
        this.$store.commit('setParams', {
          paramsName: 'clientsParams',
          params: {
            qLastName: splitted[1] || splitted[2] || '',
            qFirstName: splitted[0] || '',
          },
        });
        const routeData = router.resolve({ name: 'clients' });
        window.open(routeData.href, '_blank');
      }
    },
    mounted: function () {
      this.getCardData();
    },
  };
</script>

<style scoped>
</style>
